// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1q2yd","col":"Table_col__3iG4S","fulfillmentStatus":"Table_fulfillmentStatus__2pQXR","emailCol":"Table_emailCol__2Apdp"};